angular.module('TurneroApp').component('coLogin', {
    controller: [
        '$window',
        'loginService',        
        '$stateParams',
        //'utilsService',
        function ($window, loginService, $stateParams) { //utilsService
            var ctrl = this;
       
            ctrl.$onInit = function () {
                //se setean los valores por defecto.
                ctrl.usuario = ""
                ctrl.clave = ""
                ctrl.setSesionId($stateParams.sesionid);
            }

            ctrl.setSesionId = function (sesionId) {
                loginService.setSesionId({
                    'sesionid': sesionId
                }).$promise.then(function (result) {
                    if (result.Url !== '') {
                        loginService.Post_Usuario_VeDi().$promise.then(function (data) 
                        {    
                            $window.location.href = result.Url;
                        }).catch(function (error) {
                        });                                             
                    }else{
                        //var error = { message: 'ERROR-ORA-20050:Ha salido de la sesión reingrese por VeDi!' };
                        //utilsService.customError(error, 'error', 'Inicio de Sesión');
                    }
                }).catch(function (error) {
                    //utilsService.errores(error);
                });
            }

            ctrl.iniciarSesion = function () {
                loginService.Login({
                    'usuario': ctrl.usuario,
                    'clave': ctrl.clave
                }).$promise.then(function (result) {
                    if (result.Url !== '') {
                        $window.location.href = result.Url;   
                    }else{
                        //var error = { message: 'ERROR-ORA-20050:Usuario / Pass incorrectos!' };
                        //utilsService.customError(error, 'error', 'Inicio de Sesión');
                    }
                }).catch(function (error) {
                    //utilsService.errores(error);
                });
            };
            
        }
    ],
    template: require('./login.html')
});



// WEBPACK FOOTER //
// ./app/components/login/loginComponent.js